import { render } from "./ErrorPage.vue?vue&type=template&id=326bcd19&scoped=true&ts=true"
import script from "./ErrorPage.vue?vue&type=script&lang=ts"
export * from "./ErrorPage.vue?vue&type=script&lang=ts"

import "./ErrorPage.vue?vue&type=style&index=0&id=326bcd19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326bcd19"]])

export default __exports__